import { forwardRef } from "react";
import { IconButton, Badge, Box, Icon } from "@chakra-ui/react";
import { useNotificationContext } from "../../../../Contexts/NotificationContext";
import useThemeColors from "../../../../hooks/useThemeColors";
import useIcons from "../../../../hooks/useIcons";
import { keyframes } from "@chakra-ui/system";

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.3); }
  100% { transform: scale(1); }
`;

const NotificationBell = forwardRef<HTMLButtonElement, any>((props, ref) => {
  const { unreadCount } = useNotificationContext();
  const colors = useThemeColors();
  const icons = useIcons();
  const hasUnread = unreadCount > 0;

  return (
    <IconButton
      ref={ref}
      {...props}
      aria-label="Notifications"
      variant="ghost"
      size="lg"
      borderRadius="lg"
      position="relative"
      _active={{ transform: "scale(0.95)" }}
      transition="all 0.2s"
    >
      <Icon as={icons.main.notifications} />
      {/* Unread Badge */}
      {hasUnread && (
        <Badge
          position="absolute"
          top="1px"
          right="1px"
          colorPalette="red"
          borderRadius="full"
          minW="18px"
          h="18px"
          fontSize="2xs"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={2}
          pointerEvents="none"
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </Badge>
      )}
      {/* Pulse Animation for New Notifications */}
      {hasUnread && (
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          w="8px"
          h="8px"
          borderRadius="full"
          bg={colors.utility.pulse}
          animation={`${pulseAnimation} 3s infinite`}
          zIndex={0}
          pointerEvents="none"
        />
      )}
    </IconButton>
  );
});

export default NotificationBell;
